module.exports = __webpack_public_path__ + "static/media/a2.b9287d99.jpg";